import React from "react";
import "../styles/Navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar">
      <h2>My Website</h2>
    </nav>
  );
};

export default Navbar;
